<template lang="pug">
  main
    NavBarGA
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns.section-title.has-text-dark
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Aplicaciones Gerencia Administrativa&nbsp
              a.button.is-black.is-rounded(@click="backPage")
                i.fas.fa-times
        .columns.has-text-centered.is-centered.has-text-dark
          .column.is-3
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-cart-arrow-down.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Inventario de equipo asignado Ductos y Terminales
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to='/Inventario/Administracion') Entrar
          .column.is-3
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-shopping-cart.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Almacén
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/Almacenes") Entrar
          .column.is-3
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-trash.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Bajas
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/Inventario/Almacen/Bajas") Entrar
        .columns.has-text-centered.is-centered.has-text-dark
          .column.is-3
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-file-signature.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Responsivas
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/Responsivas") Entrar
          .column.is-3
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-shopping-cart.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Requisiciones
                br
                NotificacionConst(:config='textosNotificaciones[0]')
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/Requisiciones") Entrar
          .column.is-3
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-shopping-cart.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Compras / Solicitudes
                br
                NotificacionConst(:config='textosNotificaciones[0]')
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/Compras-Solicitudes") Entrar
        .columns.column-blanco
</template>

<script>
import Loader from '@/components/shared/Loader.vue'
import NavBarGA from '@/components/layout/NavBarGA.vue'
import NotificacionConst from '@/components/shared/NotificacionConst.vue'
import { mapState } from 'vuex'

export default {
  name: 'HomeGA',
  components: { Loader, NavBarGA, NotificacionConst },
  data () {
    return {
      isLoading: false,
      textosNotificaciones: [
        {titulo: 'En contrucción', fecha: '22/09/2020', texto: 'Act.', tipo: 'c'},
        {titulo: 'En proyecto', fecha: '22/09/2020', texto: 'Act.', tipo: 'pr'},
        {titulo: 'En pruebas', fecha: '22/09/2020', texto: 'Act.', tipo: 'p'}
      ],
    }
  },
  methods: {
    obtenerUser() {
      if (Object.keys(this.userLogin).length === 0) {
        this.$router.push('/')
      } 
    },
    backPage() {
      this.$router.back()
    },
  },
  created () {
    this.obtenerUser()
  },
  computed: {
    ...mapState(['logueado', 'userLogin'])
  },
}
</script>

<style lang="css" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
  .image {
    display: inline-block;
  }
  .card:hover {
    transform: translateY(-5px) scale(1.005) translateZ(0);
    box-shadow: 0 24px 36px rgba(0,0,0,0.11), 0 14px 16px rgba(0,0,0,0.11);
  }

  .section-title {
    margin-top: 1rem;
    margin-bottom: 2rem;
  }

  .card {
    color: #54545c;
  }
</style>




// WEBPACK FOOTER //
// src/components/apartados/ApartadoActivos.vue